import { DashboardService } from './../../shared/services/dashboard.service';
import { ActivatedRoute } from '@angular/router';
import { NotificationService } from './../../shared/services/notifications.service';
import { Component, OnInit } from '@angular/core';
import { ToastrManager } from 'ng6-toastr-notifications';

// services
import { AuthService } from 'src/app/shared/services/auth.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

  public loadingSpinner:boolean;
  public indicators: any;
  
  constructor(
    public auth:AuthService,
    private aRoute:ActivatedRoute,
    private notificationServ:NotificationService,
    private dashboardServ:DashboardService,
  ) {
    this.loadingSpinner=false;
    this.indicators={};
  }

  ngOnInit() {
    this.aRoute.queryParams.subscribe(boas_vindas => {
      if (boas_vindas.boas_vindas === 'bemvindo') {
        this.notificationServ.notify('success', 'Seja bem vindo de volta: ' + this.auth.user.name, true)
      }
    })

    this.loadingSpinner=true
    this.dashboardServ.getAllIndicators()
    .subscribe(indicators=>{
      this.indicators=indicators
      this.loadingSpinner=false
    },()=> this.loadingSpinner=false)
  }

}
